import store from '@/store';
import { checkIsContract, checkIsP, isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';
import router from '@/router';

export const MORE_OBJECT_LIST = {
  MEMORIAL: { title: '추모관 관리', pushUrl: '/more/memorial' },
  ANNOUNCEMENT: { title: '온라인 부고장 관리', pushUrl: '/more/announcement' },
  FUNERAL: { title: '온라인 장례식장 관리', pushUrl: '/more/funeral' },
  BUY: { title: '상품구매', pushUrl: '/more/item/buy' },
  PAYMENT: { title: '결제내역', pushUrl: '/more/payment' },
  TICKET: { title: '추모관 이용권 사용', pushUrl: '/more/memorial/item' },
  PRODUCT: { title: '내 상품', pushUrl: '/more/item' },
  PREMIUM_POINT: { title: '내 프리미엄 포인트', pushUrl: '/more/premium' },
  // 260826: 마이 빠른메뉴를 상위 5개로 줄이면서 내려온 항목들.
  //   ⚠️ 위쪽 LIKE 키는 추모관 게시글용(→/more/inquiry)이라 이름만 비슷하고 완전히 다른 것이다. 재사용 금지.
  LIKE_BUSINESS: { title: '좋아요한 사업장', pushUrl: '/more/like/business' },
  SUBSCRIBE_BUSINESS: { title: '구독한 사업장', pushUrl: '/more/subscribe/business' },
  COUPON: { title: '쿠폰함', pushUrl: '/event/coupon' },
  // 260626 비즈톡: 받은/보낸 비즈톡 목록 (영업형 사업장 1:1 채팅)
  TALK: { title: '비즈톡', pushUrl: '/talk' },
  // 260708 온라인 현판: 오프라인 디지털 간판 설치 신청 진입점은 나의 간판(/business/my), QR 받은 명함은 명함(/card/my '받은 명함' 탭)에 통합.
  INTEREST: { title: '관심 업종 설정', pushUrl: '/more/interest-category' },
  MY_LOCATION: { title: '내 위치 설정', pushUrl: '/more/my-location' },
  // 260611 typeC: 시안 카피로 변경 (사용처 마이페이지 1곳 — grep 확인)
  PREMIUM_CHANGE: { title: '프리미엄 회원으로 전환', pushUrl: '/change/premium' },
  DIARY: { title: '다이어리', pushUrl: '/diary' },
  CHURCH: { title: '교회,기독교 묘원 및 단체 소속 신청' },
  DEATH_CERTIFICATED: { title: '사망확인서 제출', pushUrl: '/more/death' },
  NOTICE: { title: '공지사항', pushUrl: '/more/notice' },
  INQUIRY: { title: '고객센터', pushUrl: '/more/inquiry' },

  SMILE: { title: '관리하실 Smile Together 메뉴를 선택해주세요.', pushUrl: '/more/inquiry' },
  CRY: { title: '관리하실 CRY Together 메뉴를 선택해주세요.', pushUrl: '/more/inquiry' },
  BUSINESS: { title: 'BUSINESS Together', pushUrl: '/more/inquiry' },
  LIKE: { title: '좋아요된 게시글을 보실 메뉴를 선택해주세요.', pushUrl: '/more/inquiry' },

  FAQ: { title: '자주 묻는 질문', pushUrl: '/more/faq' },
  LAW: { title: '법률검토' },
  // LAW: { title: '법률검토', pushUrl: '/more/law' },
  // 260521: MORE_SETTING_LIST.TERMS와 동일 url로 마이페이지 진입점도 추가.
  // 다른 세션이 MoreCard에서 MORE_OBJECT_LIST.TERMS를 참조했지만 키 자체가 없어
  // undefined item이 빈 카드로 렌더되던 버그 fix.
  TERMS: { title: '이용약관', pushUrl: '/signup/terms?title=서비스%20이용약관' },
  SHARE: { title: '공유하기' },
  COMPANY: { title: '함께하는 기업' }
};

export const MORE_SETTING_LIST = {
  MARKETING: { title: '마케팅 수신 동의' },
  BUSINESS_MARKETING: { title: '비즈니스 투게더 마케팅 수신 동의' },
  TERMS: { title: '이용약관', pushUrl: '/signup/terms?title=서비스%20이용약관' }
  // MEMO: 가족 삭제
  // MANAGEMENT: { title: '가족관리', pushUrl: '/more/setting/family' },
  // SEARCH: { title: '가족검색', pushUrl: '/more/setting/family/search' },
  // CREATE: { title: '가족생성', pushUrl: '/more/setting/family/register' },
  // INVITE: { title: '가족초대' }
};

export const URL_BLACK_LIST = [
  '/announcement',
  '/welldying',
  '/more',
  '/memorial/select/register',
  '/memorial/register/form/ticket',
  '/memorial/register/information',
  '/funeral/form'
];
// 260710 프리미엄관 — 비로그인 소비자 열람 공개(공개 API·게스트 가드까지 공개 설계) → /more 블랙리스트 예외 등재
export const URL_WHITE_LIST = [/^\/announcement\/\d+$/, '/more/premium-hall'];
export const isUrlAllowed = url => {
  return URL_WHITE_LIST.some(pattern => {
    if (typeof pattern === 'string') {
      return pattern === url;
    } else if (pattern instanceof RegExp) {
      return pattern.test(url);
    }
    return false;
  });
};
export const URL_GUARD = async url => {
  console.log(url);
  const user = store.getters['user/getUserData'];
  for (let blockedUrl of URL_BLACK_LIST) {
    if ((url === blockedUrl || url.includes(blockedUrl)) && isEmpty(user.userNo) && !isUrlAllowed(url)) {
      if (url === '/more/inquiry/withdraw/register') return;
      if (url === '/more/inquiry/register') return;
      showTextModal('로그인 후 이용가능합니다.', '확인', () => {
        store.commit('layout/setLoginMovePath', url); // 260821 — URL_GUARD 인자가 곧 목적지(복귀 경로 누락분)
        router.push(`/signin`);
      }, url.startsWith('/more/qr-') ? 'qr-blue' : null);
    }
  }
};

export const TEST_BACKGROUND_LIST = [
  {
    backgroundImageNo: 1,
    storedFileName: 'bg-image01',
    isLock: false
  },
  {
    backgroundImageNo: 2,
    storedFileName: 'bg-image02',
    isLock: false
  },
  {
    backgroundImageNo: 3,
    storedFileName: 'bg-image03',
    isLock: true
  },
  {
    backgroundImageNo: 4,
    storedFileName: 'bg-image04',
    isLock: true
  },
  {
    backgroundImageNo: 5,
    storedFileName: 'bg-image05',
    isLock: true
  },
  {
    backgroundImageNo: 6,
    storedFileName: 'bg-image06',
    isLock: true
  }
];

export const TEST_FRAME_LIST = [
  {
    frameNo: 1,
    storedFileName: 'photo-frame'
  },
  {
    frameNo: 2,
    storedFileName: 'portraitPhoto'
  }
];

export const MORE_MAIN_BOTTOM = {
  isFamily: {
    text: '지금 활성화 중인 가족을 변경할 수 있어요'
  },
  FAMILY_SEARCH: {
    title: '가족 검색하기',
    pushURL: '/more/setting/family/search',
    text: '기존의 가족의 구성원이 되어 보세요'
  },
  FAMILY_ADD: {
    title: '가족 생성하기',
    pushURL: '/more/setting/family/register',
    text: '새로운 가족을 만들어 보세요'
  }
};
export const PAGING_LIMIT = 10;
